const state = {
  activeRoute: null,
  navigationEnabled: false,
  nextInstruction: null,
  routeInstructions: [],
  distanceToNextTurn: null,
  isOffRoute: false,
  routeFailure: false,
  calculatingRoute: false
}

const mutations = {
  SET_ACTIVE_ROUTE(state, route) {
    state.activeRoute = route
  },
  SET_NAVIGATION_ENABLED(state, enabled) {
    state.navigationEnabled = enabled
  },
  SET_NEXT_INSTRUCTION(state, instruction) {
    state.nextInstruction = instruction
  },
  SET_ROUTE_INSTRUCTIONS(state, instructions) {
    state.routeInstructions = instructions
  },
  SET_DISTANCE_TO_NEXT_TURN(state, distance) {
    state.distanceToNextTurn = distance
  },
  SET_IS_OFF_ROUTE(state, isOffRoute) {
    state.isOffRoute = isOffRoute
  },
  SET_ROUTE_FAILURE(state, failure) {
    state.routeFailure = failure
  },
  SET_CALCULATING_ROUTE(state, calculating) {
    state.calculatingRoute = calculating
  }
}

const actions = {
  setActiveRoute({ commit }, route) {
    commit('SET_ACTIVE_ROUTE', route)
  },
  setNavigationEnabled({ commit }, enabled) {
    commit('SET_NAVIGATION_ENABLED', enabled)
  },
  setNextInstruction({ commit }, instruction) {
    commit('SET_NEXT_INSTRUCTION', instruction)
  },
  setRouteInstructions({ commit }, instructions) {
    commit('SET_ROUTE_INSTRUCTIONS', instructions)
  },
  setDistanceToNextTurn({ commit }, distance) {
    commit('SET_DISTANCE_TO_NEXT_TURN', distance)
  },
  setIsOffRoute({ commit }, isOffRoute) {
    commit('SET_IS_OFF_ROUTE', isOffRoute)
  },
  setRouteFailure({ commit }, failure) {
    commit('SET_ROUTE_FAILURE', failure)
  },
  setCalculatingRoute({ commit }, calculating) {
    commit('SET_CALCULATING_ROUTE', calculating)
  },
  stopNavigation({ commit }) {
    commit('SET_ACTIVE_ROUTE', null)
    commit('SET_NAVIGATION_ENABLED', false)
    commit('SET_NEXT_INSTRUCTION', null)
    commit('SET_ROUTE_INSTRUCTIONS', [])
    commit('SET_DISTANCE_TO_NEXT_TURN', null)
    commit('SET_IS_OFF_ROUTE', false)
    commit('SET_ROUTE_FAILURE', false)
    commit('SET_CALCULATING_ROUTE', false)
  },
  clearRouteError({ commit }) {
    commit('SET_ROUTE_FAILURE', false)
  }
}

const getters = {
  activeRoute: state => state.activeRoute,
  navigationEnabled: state => state.navigationEnabled,
  nextInstruction: state => state.nextInstruction,
  routeInstructions: state => state.routeInstructions,
  distanceToNextTurn: state => state.distanceToNextTurn,
  isOffRoute: state => state.isOffRoute,
  routeFailure: state => state.routeFailure,
  calculatingRoute: state => state.calculatingRoute
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 